import React, { useState, useEffect } from 'react';
import { message, Table, Button, Form } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import SelectWithFetch from '../../common/selectWithFetch'
import { searchGlobalService } from '../../../graphql/queries';
import { withApollo } from 'react-apollo';


const InvestigationComp = (props, objD) => {
  // const context = useContext(CasesheetContext)
  const [selectExm, setselectExm] = useState([]);
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState(false);


  useEffect(() => {
    if (props.form) {
      let values = props.form.getFieldsValue();
      let arr = values.investigationMap;

      if (values.investigation != null) {
        let obj = values.investigation.map((a) => {
          if (a) {
            let item = null;
            if (arr && arr.length > 0) {
              item = arr.find((b) => b && b.serviceCode == a)
            }
            if (item) {
              return { serviceName: item.serviceName, id: a }
            } else {
              return { serviceName: a, id: a }
            }
          }
        });
        setselectExm(obj)
      }
    }
  }, [])


  const handleDelete = (record) => {
    let arr = [...selectExm];
    let i = arr.findIndex((item) => item.id == record.id);

    if (i > -1) {
      arr.splice(i, 1);
      setselectExm(arr)
    }

    if (props.form) {
      props.form.setFieldsValue({
        investigation: arr
      })
    }
    message.success('Deleted successfully')
  }


  const handleFetchData = (val) => {
    setloading(true)
    props.client.query({
      query: searchGlobalService,
      variables: {
        searchValue: val,
        from: 0,
        size: 100
      },
    }).then((data) => {
      if (data.data.searchGlobalService) {
        setdata(data.data.searchGlobalService)
      }
      setloading(false)
    }).catch((err) => {
      console.log(err)
      setloading(false)
    })

  }

  const columns = [
    {
      title: 'Investigation',
      dataIndex: 'serviceName',
      key: 'Investigation',

    },

    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render(text, record) {
        return (
          <Button type="link">
            <DeleteFilled
              onClick={() => {
                handleDelete(record)
              }} />
          </Button>)
      }
    },
  ];


  return (
    <div>


      {/* <MultiSelectEXM
           selectedTest={selectedTest}
           data={dataList}
           
            /> */}
      <SelectWithFetch
        // type="multi"
        loading={loading}
        size="large"
        placeholder="Type to Search Investigation"
        // selected={selectExm}
        // custVal={selectExm}
        dropDownEnabled={true}
        dropDownComp={<>

        </>}
        handleSearch={(val) => {
          handleFetchData(val)
        }}
        data={data}
        keyName={'serviceCode'}
        fields={[
          {
            title: null,
            val: 'serviceCode'
          }, {
            title: null,
            val: 'serviceName'
          },]}
        setSelectedResult={(val) => {
          let arr = [...selectExm]

          let item = arr.find((a)=>a.id == val.value)
      
          if(item){
            message.warning('Already added')
            return
          }

          arr.push({
            serviceName: val.serviceName ? val.serviceName : val.label,
            id: val.id ? val.id : val.value
          })
          let modArr = arr.map((a) => a.id)
          setselectExm(arr)
          if (props.form) {
            props.form.setFieldsValue({
              investigation: modArr
            })
          }
        }}
      />

      <Table
        style={{ marginTop: 20 }}
        columns={columns}
        dataSource={selectExm}
      />

      <Form.Item
        rules={[{ required: false, message: 'Investigation is required' }]}
        name="investigation"
      >
        <p></p>
      </Form.Item>

      <Form.Item

        name="investigationMap"
      >
        <p></p>
      </Form.Item>


    </div>
  )
}

export default withApollo(InvestigationComp)